import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(_to, _from, savedPosition) {
    return savedPosition ?? { top: 0 }
  },
  routes: [
    {
      path: '/',
      component: () => import('@/layouts/tab-layout'),
      children: [
        // 首页
        { path: '', component: () => import('@/pages/home') },
        // 图库 Tab（对应 49208 的「发现」）
        { path: 'find', component: () => import('@/pages/find') },
        // 寻宝（网址大全 + 担保平台）
        { path: 'treasure', component: () => import('@/pages/treasure') },
        // 我的
        { path: 'my', component: () => import('@/pages/my') },
      ],
    },
    // 高手之家（底部中间凸起按钮，全屏页不带底部导航）
    { path: '/gszj', component: () => import('@/pages/gszj') },
    // 高手之家-发帖
    { path: '/gszj/publish', component: () => import('@/pages/gszj-publish') },
    // 高手之家-用户个人页
    { path: '/gszj/user/:id', component: () => import('@/pages/gszj-user') },
    // 高手之家-历史开奖记录
    { path: '/gszj/history', component: () => import('@/pages/gszj-history') },
    // 高手之家-图库（论坛 tab「图库」胶囊跳转）
    { path: '/gszj/gallery', component: () => import('@/pages/gszj-gallery') },
    // 高手之家-我的关注 / 我的粉丝（「我的」tab 统计项跳转）
    { path: '/gszj/follows', component: () => import('@/pages/gszj-follow-list') },
    { path: '/gszj/fans', component: () => import('@/pages/gszj-follow-list') },
    // 他人主页的「他的关注 / 他的粉丝」（#275，公开，按目标用户 ID）
    { path: '/gszj/user/:id/follows', component: () => import('@/pages/gszj-follow-list') },
    { path: '/gszj/user/:id/fans', component: () => import('@/pages/gszj-follow-list') },
    // 高手之家-榜单说明（高手 tab 榜单说明栏点击）
    { path: '/gszj/tips', component: () => import('@/pages/gszj-tips') },
    // 高手之家-帖子详情（用户×玩法逐期明细）
    { path: '/gszj/post', component: () => import('@/pages/gszj-post') },
    // 登录
    { path: '/login', component: () => import('@/pages/login') },
    // 注册
    { path: '/register', component: () => import('@/pages/register') },
    // 用户中心
    { path: '/settings', component: () => import('@/pages/settings') },
    { path: '/set-name', component: () => import('@/pages/set-name') },
    { path: '/set-phone', component: () => import('@/pages/set-phone') },
    { path: '/set-new-phone', component: () => import('@/pages/set-new-phone') },
    { path: '/change-password', component: () => import('@/pages/change-password') },
    { path: '/user/:id', component: () => import('@/pages/user-profile') },
    { path: '/my-collections', component: () => import('@/pages/my-collections') },
    { path: '/my-comments', component: () => import('@/pages/my-comments') },
    { path: '/my-follows', component: () => import('@/pages/my-follows') },
    { path: '/my-fans', component: () => import('@/pages/my-fans') },
    { path: '/my-likes', component: () => import('@/pages/my-likes') },
    // 粉丝排行榜（全站统一 Top 149）
    { path: '/top-fans-rank', component: () => import('@/pages/top-fans-rank') },
    // 黑名单
    { path: '/blacklist', component: () => import('@/pages/blacklist') },
    // 忘记密码
    { path: '/forgot-password', component: () => import('@/pages/forgot-password') },
    // 开奖历史
    { path: '/history', component: () => import('@/pages/history') },
    // 查询助手
    { path: '/query-helper', component: () => import('@/pages/query-helper') },
    // 帮助中心
    { path: '/help', component: () => import('@/pages/help') },
    // 联系客服
    {
      path: '/contact-customer-service',
      component: () => import('@/pages/contact-customer-service'),
    },
    // 站内信息-消息中间页
    { path: '/sitemsg', component: () => import('@/pages/sitemsg') },
    // 站内信息-系统通知列表
    { path: '/sitemsg/system', component: () => import('@/pages/sitemsg-system') },
    // 开奖详情
    { path: '/lottery/:issueNo', component: () => import('@/pages/lottery-detail') },
    // 图库搜索（按年份和颜色）—— 须在 /gallery/:id 之前定义，避免路由冲突
    { path: '/gallery/search', component: () => import('@/pages/gallery-search') },
    // 图库分类列表
    { path: '/gallery/categories', component: () => import('@/pages/gallery-categories') },
    // 图库分类页
    { path: '/gallery/category/:id', component: () => import('@/pages/gallery-category') },
    // 图库详情页关联的图解列表（须在 /gallery/:id 之前定义）
    {
      path: '/gallery/:tukuId/illustrations',
      component: () => import('@/pages/gallery-illustrations'),
    },
    // 图库投票记录（须在 /gallery/:id 之前定义）
    { path: '/gallery/:id/vote-records', component: () => import('@/pages/gallery-vote-records') },
    // 图库详情页
    { path: '/gallery/:id', component: () => import('@/pages/gallery-detail') },
    // 开奖现场
    { path: '/live', component: () => import('@/pages/live') },
    // 回放列表
    { path: '/video-list', component: () => import('@/pages/video-list') },
    // 回放详情
    { path: '/video/:period', component: () => import('@/pages/video-detail') },
    // 资讯统计 — 全部页面共享 stats-tab-layout（底部 Tab + 顶部 Header）
    {
      path: '/stats',
      component: () => import('@/layouts/stats-tab-layout'),
      children: [
        { path: '', component: () => import('@/pages/stats/lotto-stats') },
        { path: 'attribute-ref', component: () => import('@/pages/stats/attribute-ref') },
        { path: 'special-history', component: () => import('@/pages/stats/special-history') },
        { path: 'regular-history', component: () => import('@/pages/stats/regular-history') },
        { path: 'tail-size', component: () => import('@/pages/stats/tail-size') },
        { path: 'zodiac-special', component: () => import('@/pages/stats/zodiac-special') },
        { path: 'zodiac-regular', component: () => import('@/pages/stats/zodiac-regular') },
        { path: 'color-special', component: () => import('@/pages/stats/color-special') },
        { path: 'color-regular', component: () => import('@/pages/stats/color-regular') },
        { path: 'special-sides', component: () => import('@/pages/stats/special-sides') },
        { path: 'special-tail', component: () => import('@/pages/stats/special-tail') },
        { path: 'regular-tail', component: () => import('@/pages/stats/regular-tail') },
        { path: 'regular-total', component: () => import('@/pages/stats/regular-total') },
        { path: 'number-band', component: () => import('@/pages/stats/number-band') },
        { path: 'domestic-wild', component: () => import('@/pages/stats/domestic-wild') },
        { path: 'combo-trend', component: () => import('@/pages/stats/combo-trend') },
        { path: 'zodiac-combo-trend', component: () => import('@/pages/stats/zodiac-combo-trend') },
      ],
    },
    // 天线宝宝
    { path: '/tinky-winky', component: () => import('@/pages/tinky-winky') },
    // 幽默猜测
    { path: '/humor-guess', component: () => import('@/pages/humor-guess') },
    // 资料大全 — 文章类型列表
    { path: '/articles', component: () => import('@/pages/article-type-list') },
    // 资料大全 — 文章列表
    { path: '/articles/list', component: () => import('@/pages/article-list') },
    // 资料大全 — 文章搜索
    { path: '/articles/search', component: () => import('@/pages/article-search') },
    // 资料大全 — 文章详情
    { path: '/articles/detail', component: () => import('@/pages/article-detail') },
    // 资料大全 — 作者文章列表
    { path: '/articles/user', component: () => import('@/pages/article-user') },
    // 发表评论
    { path: '/comment/new', component: () => import('@/pages/comment-new') },
    // 六合论坛（阶段一：首页骨架 + 规则页；阶段二：发帖页；阶段三：帖子详情页）
    { path: '/forum', component: () => import('@/pages/forum') },
    { path: '/forum/rules', component: () => import('@/pages/forum-rules') },
    { path: '/forum/publish', component: () => import('@/pages/forum-publish') },
    { path: '/forum/search', component: () => import('@/pages/forum-search') },
    { path: '/forum/detail/:id', component: () => import('@/pages/forum-detail') },
    // 六合论坛 - 获奖榜单（issue #42）
    { path: '/forum/award-ranking', component: () => import('@/pages/forum-award-ranking') },
    { path: '/forum/power-ranking', component: () => import('@/pages/forum-power-ranking') },
    { path: '/forum/power-rule', component: () => import('@/pages/forum-power-rule') },
    { path: '/forum/my-power', component: () => import('@/pages/forum-my-power') },
    // 六合论坛 — 作者历史帖子（对应 49208 /find-user）
    { path: '/forum/user-posts', component: () => import('@/pages/forum-user-posts') },
    // 下载 APP
    { path: '/download-app', component: () => import('@/pages/download-app') },
    // iOS 安装说明
    { path: '/ios-install-guide', component: () => import('@/pages/ios-install-guide') },
  ],
})

export default router
